<store-form [data]="item"
            (submited)="onSubmit($event)">
  <button class="btn btn-success float-right" type="submit">Save</button>

  <btn-delete form actions type="store" #btnDelete
              [name]="initial || id"
              (delete)="delete($event)">
  </btn-delete>
</store-form>
